module.exports = __webpack_public_path__ + "static/media/Timer 8.61fc6358.png";